var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidTier4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 80,
    viewBox: "0 0 94 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1969 78.1575L90.6808 59.4411C92.4269 58.5681 93.3011 56.8867 93.3032 55.2043V50.0381H0.664062V55.2043C0.66622 56.8867 1.54035 58.5681 3.28645 59.4411L39.7703 78.1575C44.3112 80.4279 49.6561 80.4279 54.1969 78.1575Z",
    fill: "url(#paint0_linear_8129_25777)",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7703 27.152C44.3112 24.8816 49.6561 24.8816 54.1969 27.152L90.6808 45.394C94.1773 47.1423 94.1774 52.132 90.6808 53.8802L54.1969 72.1222C49.6561 74.3926 44.3112 74.3926 39.7703 72.1222L3.28645 53.8802C-0.210065 52.132 -0.21007 47.1423 3.28645 45.394L39.7703 27.152Z",
    fill: "url(#paint1_linear_8129_25777)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1983 72.1226L90.6822 53.8806C92.2738 53.0848 93.1409 51.6174 93.2835 50.0898C92.2381 52.4824 91.8046 52.6269 90.4828 53.4133L54.0853 71.4212C53.049 71.8855 50.2321 73.0922 46.8035 73.0922C43.3748 73.0922 40.7548 71.8855 39.8394 71.4212C28.1474 65.564 4.41403 53.9776 3.28782 53.3776C2.16161 52.7775 1.16835 51.4248 0.8125 50.8235C1.12847 52.0744 1.95358 53.2135 3.28782 53.8806L39.7717 72.1226C44.3126 74.393 49.6574 74.393 54.1983 72.1226Z",
    fill: "url(#paint2_linear_8129_25777)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8129_25777)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9279 16.8997C44.9546 14.8863 49.6942 14.8863 53.7208 16.8996L86.0733 33.0759C89.1739 34.6262 89.1739 39.0508 86.0733 40.6011L53.7208 56.7774C49.6942 58.7907 44.9546 58.7907 40.9279 56.7774L8.57543 40.6011C5.47486 39.0508 5.47485 34.6262 8.57543 33.0759L40.9279 16.8997Z",
    fill: "url(#paint3_linear_8129_25777)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 36.8389V42.218C6.25191 43.7099 7.02706 45.2009 8.57543 45.9751L40.9279 62.572C44.9546 64.5854 49.6942 64.5854 53.7208 62.572L86.0733 45.9751C87.6217 45.2009 88.3968 43.7099 88.3987 42.218V36.848C88.3956 38.3387 87.6204 39.8279 86.0733 40.6015L53.7208 56.7777C49.6942 58.7911 44.9546 58.7911 40.9279 56.7777L8.57543 40.6015C7.02515 39.8263 6.25 38.3326 6.25 36.8389Z",
    fill: "url(#paint4_linear_8129_25777)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7232 56.777L86.0757 40.6008C87.487 39.8951 88.256 38.5939 88.3824 37.2393C87.4554 39.3609 87.071 39.489 85.8989 40.1863L53.623 56.1551C52.7041 56.5668 50.2061 57.6368 47.1658 57.6368C44.1254 57.6368 41.802 56.5668 40.9904 56.1551C30.6223 50.9611 9.57651 40.6867 8.57783 40.1547C7.57915 39.6226 6.69837 38.4231 6.38281 37.8898C6.663 38.9991 7.39468 40.0092 8.57783 40.6008L40.9303 56.777C44.957 58.7903 49.6966 58.7903 53.7232 56.777Z",
    fill: "url(#paint5_linear_8129_25777)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_8129_25777)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0125 8.80305C45.141 7.23883 48.8233 7.23883 51.9517 8.80304L77.0872 21.3708C79.4962 22.5753 79.4962 26.0129 77.0872 27.2174L51.9517 39.7852C48.8233 41.3494 45.141 41.3494 42.0125 39.7852L16.877 27.2174C14.4681 26.0129 14.4681 22.5753 16.877 21.3708L42.0125 8.80305Z",
    fill: "url(#paint6_linear_8129_25777)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 24.2939V29.6117C15.0718 30.7708 15.674 31.9292 16.877 32.5307L42.0125 45.4253C45.141 46.9895 48.8233 46.9895 51.9517 45.4253L77.0873 32.5307C78.2902 31.9292 78.8925 30.7708 78.8939 29.6117V24.301C78.8915 25.4592 78.2893 26.6162 77.0873 27.2172L51.9517 39.785C48.8233 41.3492 45.141 41.3492 42.0125 39.785L16.877 27.2172C15.6725 26.615 15.0703 25.4545 15.0703 24.2939Z",
    fill: "url(#paint7_linear_8129_25777)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9598 39.7849L77.0953 27.2171C78.1918 26.6689 78.7892 25.6579 78.8875 24.6055C78.1672 26.2538 77.8686 26.3534 76.9579 26.8951L51.8819 39.3017C51.1679 39.6216 49.2272 40.4529 46.8651 40.4529C44.5029 40.4529 42.6979 39.6216 42.0672 39.3017C34.012 35.2663 17.661 27.2839 16.8851 26.8705C16.1092 26.4572 15.4249 25.5252 15.1797 25.1109C15.3974 25.9727 15.9658 26.7575 16.8851 27.2171L42.0206 39.7849C45.149 41.3491 48.8313 41.3491 51.9598 39.7849Z",
    fill: "url(#paint8_linear_8129_25777)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_8129_25777)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0462 1.73256C45.3721 0.569618 48.1097 0.569616 50.4356 1.73255L69.123 11.0762C70.9139 11.9717 70.9139 14.5275 69.123 15.423L50.4356 24.7666C48.1097 25.9296 45.3721 25.9296 43.0462 24.7666L24.3588 15.423C22.5679 14.5275 22.5679 11.9717 24.3588 11.0762L43.0462 1.73256Z",
    fill: "url(#paint9_linear_8129_25777)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bi_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0156 13.25V17.6444C23.0167 18.5062 23.4645 19.3674 24.3588 19.8146L43.0462 29.4013C45.3721 30.5642 48.1097 30.5642 50.4356 29.4013L69.123 19.8146C70.0174 19.3674 70.4651 18.5062 70.4662 17.6444V13.2553C70.4644 14.1163 70.0166 14.9765 69.123 15.4234L50.4356 24.767C48.1097 25.93 45.3721 25.93 43.0462 24.767L24.3588 15.4234C23.4634 14.9756 23.0156 14.1128 23.0156 13.25Z",
    fill: "url(#paint10_linear_8129_25777)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_8129_25777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4384 24.7668L69.1258 15.4231C69.941 15.0155 70.3851 14.2639 70.4582 13.4814C69.9227 14.7069 69.7007 14.781 69.0236 15.1837L50.3806 24.4075C49.8497 24.6454 48.4069 25.2634 46.6507 25.2634C44.8945 25.2634 43.5525 24.6454 43.0837 24.4075C37.0949 21.4074 24.9385 15.4728 24.3616 15.1654C23.7848 14.8581 23.276 14.1652 23.0938 13.8572C23.2556 14.4979 23.6782 15.0814 24.3616 15.4231L43.049 24.7668C45.3749 25.9297 48.1125 25.9297 50.4384 24.7668Z",
    fill: "url(#paint11_linear_8129_25777)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8129_25777",
    x: 0.664062,
    y: 49.8009,
    width: 92.6387,
    height: 30.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_8129_25777",
    x: -10.5127,
    y: 14.2724,
    width: 114.992,
    height: 70.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.58839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8129_25777",
    x: 0.477197,
    y: 49.7545,
    width: 93.1413,
    height: 24.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167652,
    result: "effect1_foregroundBlur_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8129_25777",
    x: 1.75647,
    y: 15.3896,
    width: 91.1355,
    height: 57.6794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_8129_25777",
    x: -4.43619,
    y: 4.70346,
    width: 103.521,
    height: 64.2703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.34309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_8129_25777",
    x: -2.16349,
    y: 28.4254,
    width: 98.9754,
    height: 44.0701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.20674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_8129_25777",
    x: 5.96214,
    y: 36.8186,
    width: 82.8413,
    height: 21.8892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337,
    result: "effect1_foregroundBlur_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_8129_25777",
    x: 11.0247,
    y: 7.62988,
    width: 71.9155,
    height: 47.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_8129_25777",
    x: -4.92969,
    y: -12.3701,
    width: 103.824,
    height: 73.3286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_8129_25777",
    x: 8.53364,
    y: 17.7573,
    width: 76.8976,
    height: 35.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.26834
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.163417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_8129_25777",
    x: 14.6797,
    y: 24.1055,
    width: 64.707,
    height: 17.3525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_8129_25777",
    x: 19.0156,
    y: 0.860352,
    width: 55.4512,
    height: 37.4131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_8129_25777",
    x: 3.01562,
    y: -19.1396,
    width: 87.4512,
    height: 64.7783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bi_8129_25777",
    x: 18.1558,
    y: 8.39022,
    width: 57.1707,
    height: 26.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.42989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25777",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.121495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_8129_25777",
    x: 22.7937,
    y: 13.1814,
    width: 47.9652,
    height: 12.7577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_8129_25777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8129_25777",
    x1: 93.3032,
    y1: 55.1551,
    x2: 0.664064,
    y2: 56.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC36A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8129_25777",
    x1: 93.3032,
    y1: 49.6371,
    x2: -0.653239,
    y2: 49.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8129_25777",
    x1: 0.8125,
    y1: 50.0898,
    x2: 93.2836,
    y2: 50.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8129_25777",
    x1: 89.981,
    y1: 36.8385,
    x2: 6.25,
    y2: 36.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A32C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8129_25777",
    x1: 88.3987,
    y1: 41.0945,
    x2: 6.25,
    y2: 41.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8129_25777",
    x1: 6.38281,
    y1: 37.2393,
    x2: 88.3825,
    y2: 37.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8129_25777",
    x1: 79.8436,
    y1: 24.2941,
    x2: 15.0703,
    y2: 24.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8129_25777",
    x1: 78.8939,
    y1: 26.9408,
    x2: 14.2115,
    y2: 24.2939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8AD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8129_25777",
    x1: 15.1797,
    y1: 24.6055,
    x2: 78.8875,
    y2: 24.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499986,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8129_25777",
    x1: 70.4662,
    y1: 13.2496,
    x2: 23.0156,
    y2: 13.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8129_25777",
    x1: 70.4662,
    y1: 16.2242,
    x2: 23.0156,
    y2: 15.3142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8129_25777",
    x1: 23.0938,
    y1: 13.4814,
    x2: 70.4582,
    y2: 13.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTier4Icon);
export default __webpack_public_path__ + "static/media/bfid-tier_4-icon.10895f06cb315f3fd236077039b1271c.svg";
export { ForwardRef as ReactComponent };